import $ from 'jquery';
import Constants from '../util/Constants';

const Pros = {

  /**
     *
     * @param request = {
     *  requester,  //mandatory
     *  productId,   //mandatory
     *  zone      //mandatory
     * }
     * @returns {Promise}
     */
  getRecommendations(request) {
    const data = Object.assign({ context: request.zone }, request);
    return $.ajax({
      url: Constants.PATH_RTO_RECOMMENDATIONS,
      type: 'POST',
      data: $.param(data),
      dataType: 'json',
      timeout: request.timeout,
    });
  },

};


export default Pros;

